import { RouterManager } from '@aclass/admin/managers';
import { DomainDetailStory } from '@aclass/admin/storage/actions';
import { IAdminState, IDomainDetailModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

@Injectable()
export class DomainDetailSearchStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:domain-detail-search';

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<IDomainDetailModuleState['searchPageInitialized']>(['domainDetailModule', 'searchPageInitialized']).pipe(
            filter(v => v)
        );
        this.employee = this.routerManager.onRejectNavigation(DomainDetailSearchStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(): void {
        this.ngRdx.dispatch(DomainDetailStory.dryRunSearchPage());
    }
}
